// extracted by mini-css-extract-plugin
export default {"container":"TitleSlider_container__cFGN7","heading":"TitleSlider_heading__EZTRs","sliderWrapper":"TitleSlider_sliderWrapper__GQl30","sliderInner":"TitleSlider_sliderInner__0Bxl7"};